import * as types from '../../action-types';
import { uploadMentors as initialState } from '../initialStates';

const uploadMentors = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.UPLOAD_MENTORS_START:
            return {
                ...state,
                isLoading: true,
            }
        case types.UPLOAD_MENTORS_SUCCESS:
            return {
                ...state,
                isSuccessful: true,
                data: payload,
            }
        case types.UPLOAD_MENTORS_FAIL:
            return {
                ...state,
                error: payload
            }
        case types.UPLOAD_MENTORS_CLEANUP:
            return {
                ...state,
                error: null,
                isSuccessful: false
            }
        default:
            return state;
    };
};

export default uploadMentors;

